import { PlatformFacade } from './facade';

const platformFacade = new PlatformFacade();

export { platformFacade };
export { PlatformSubscriptionsFacade } from './subscriptions';
export { PlatformVMSFacade } from './vms';
export type { PlatformEntitlements, PlatformSubscription } from './types';
